// extracted by mini-css-extract-plugin
export default {"button":"Bo-z","reviewSort":"Co-z"};